// Version configuration for Chatbot
export const VERSION = 'v1.2.5';
export const BUILD_DATE = new Date().toISOString().split('T')[0]; // YYYY-MM-DD format
